/**
 * Aduce in avans fotografiile galeriei de produs.
 *
 * DE CE: tema ascunde cu `display: none` fotografiile care nu sunt active
 * (`.product--thumbnail .product__media-item:not(.is-active)`), iar ele au
 * `loading="lazy"`. Un element fara cutie de layout nu se apropie niciodata de
 * ecran, deci browserul nu le aduce NICIODATA in avans: descarcarea porneste
 * abia in clipa in care vizitatorul apasa miniatura.
 *
 * Masurat pe magazin, pe telefon si retea 4G inceata: 1,8 - 3,4 secunde de gol
 * la fiecare schimbare de fotografie.
 *
 * CE FACE: dupa ce pagina s-a linistit, trece fotografiile amanate pe
 * `loading="eager"`, ceea ce porneste descarcarea chiar si pentru un element
 * ascuns (verificat: elementul ramane `display: none`, imaginea se descarca).
 *
 * Le ia UNA CATE UNA, in ordinea din galerie: pe o conexiune slaba, cinci
 * descarcari pornite deodata s-ar incurca intre ele si ar intarzia si prima
 * fotografie, cea care chiar se vede.
 *
 * NU atinge fereastra de marire. Acolo fotografiile sunt mult mai mari si sunt
 * ascunse tot cu `display: none` (vezi `section-main-product-almam.css`) -
 * exact ca sa NU se descarce degeaba. De aceea selectorul porneste strict din
 * `media-gallery`.
 */
(function () {
  'use strict';

  /** Plasa de siguranta: cat asteptam dupa `load` daca prima fotografie nu raspunde. */
  var RAGAZ_MS = 1200;

  /** Plasa de siguranta: daca o fotografie nu raspunde, trecem la urmatoarea. */
  var LIMITA_PER_FOTOGRAFIE_MS = 15000;

  /**
   * Cate fotografii aducem cel mult, in plus fata de cea deja vizibila.
   *
   * Masurat pe /products/hanorac-3-4: cinci fotografii inseamna ~347 KB in plus,
   * cerute dupa `load`. Pentru o galerie obisnuita e un schimb bun - cine ajunge
   * pe pagina de produs le rasfoieste - dar la un produs cu douazeci de
   * fotografii ar fi risipa, de aceea plafonul.
   */
  var CATE_CEL_MULT = 6;

  function conexiuneNepotrivita() {
    var c = navigator.connection;
    if (!c) return false;
    if (c.saveData) return true;
    return c.effectiveType === 'slow-2g' || c.effectiveType === '2g';
  }

  function fotografiiAmanate() {
    var galerie = document.querySelector('media-gallery .product__media-list');
    if (!galerie) return [];
    var toate = Array.prototype.slice.call(galerie.querySelectorAll('img[loading="lazy"]'));
    return toate.slice(0, CATE_CEL_MULT);
  }

  function adu(imagini, i) {
    if (i >= imagini.length) return;

    var img = imagini[i];
    var terminat = false;

    function urmatoarea() {
      if (terminat) return;
      terminat = true;
      adu(imagini, i + 1);
    }

    if (img.complete && img.naturalWidth > 0) {
      urmatoarea();
      return;
    }

    img.addEventListener('load', urmatoarea, { once: true });
    img.addEventListener('error', urmatoarea, { once: true });
    setTimeout(urmatoarea, LIMITA_PER_FOTOGRAFIE_MS);

    img.loading = 'eager';
  }

  var pornit = false;

  function porneste() {
    if (pornit) return;
    pornit = true;

    if (conexiuneNepotrivita()) return;

    var imagini = fotografiiAmanate();
    if (!imagini.length) return;

    adu(imagini, 0);
  }

  function laRagaz() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(porneste, { timeout: 3000 });
    } else {
      porneste();
    }
  }

  /**
   * Momentul pornirii: cand prima fotografie s-a terminat de descarcat.
   *
   * Prima incercare astepta `load`-ul intregii pagini plus o secunda. Pe magazin
   * `load` vine dupa 4-6 secunde, fiindca aplicatiile instalate cer peste o suta
   * de resurse - masurat 99 de cereri concurente doar in fereastra in care
   * fotografia principala astepta. Cine apasa sageata pana atunci nu are nimic
   * pregatit, adica exact reclamatia primita.
   *
   * Reperul corect nu e „pagina gata", ci „prima fotografie gata": din clipa
   * aceea nu mai fur banda de la elementul care chiar se vede.
   */
  function candPrimaEGata() {
    var activa = document.querySelector(
      'media-gallery .product__media-item.is-active img, media-gallery .product__media-list img'
    );

    if (!activa || (activa.complete && activa.naturalWidth > 0)) {
      laRagaz();
      return;
    }

    activa.addEventListener('load', laRagaz, { once: true });
    activa.addEventListener('error', laRagaz, { once: true });

    // daca fotografia principala nu raspunde, tot pornim, dupa `load`-ul paginii
    window.addEventListener('load', function () { setTimeout(laRagaz, RAGAZ_MS); }, { once: true });
  }

  /**
   * Al doilea declansator: primul contact cu galeria.
   *
   * Ragazul de mai sus asteapta `load` plus inca o secunda. Cine apasa sageata
   * mai devreme - si se intampla des, sageata e chiar peste fotografie - nu are
   * inca nimic pregatit si asteapta descarcarea pe loc. De aceea orice atingere,
   * trecere cu mausul sau focus pe galerie ori pe banda de miniaturi porneste
   * aducerea imediat, fara sa mai astepte.
   *
   * `porneste` e idempotenta, deci nu conteaza care dintre declansatoare ajunge
   * primul.
   */
  function legContactul() {
    var zona = document.querySelector('media-gallery');
    if (!zona) return;

    var evenimente = ['pointerdown', 'pointerover', 'focusin', 'touchstart'];
    evenimente.forEach(function (ev) {
      zona.addEventListener(ev, porneste, { once: true, passive: true, capture: true });
    });
  }

  function laStart() {
    legContactul();
    candPrimaEGata();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', laStart, { once: true });
  } else {
    laStart();
  }
})();
